__turbopack_context__.v({
  "fast": "work-line-shadow-module__anb-Uq__fast",
});
